import { baseAction } from "./baseAction";
import { authConstant, loaderConstant, dashboardConstant } from "../constants";
import { authService } from "../services";

import history from "../../config/history";
import { removeToken, setToken, getDeviceId, setRfToken } from "../../utils/appHelper";
import { isIOS, isAndroid, isDesktop } from 'react-device-detect';

const { request, success, failure } = baseAction;

export const authAction = {
  login,
  logout,
  getProfileData,
  getUpdatedStatus,
  pageRedirect,
  getUserLoginForDevice,
  updateSocketStatus
};

/**
 * Request Login
 */
function login(params, urlRedirectType, onboarding = '', callback = () => { }) {
  return (dispatch) => {
    dispatch(request(authConstant.USER_LOGIN_R));
    dispatch(request(loaderConstant.LOADING_TRUE));
    authService.login(params).then((data) => {
      dispatch(request(loaderConstant.LOADING_FALSE));
      if (data.message === "success" || data.message === "Your access has been expired") {
        dispatch(success(authConstant.USER_LOGIN_S, data));
        if(data?.data?.checkSpecialFlag?.special_flagged_agencies){
          dispatch(success('SET_SPECIAL_USER',data))
        }
        setToken(data.data.token);
        setRfToken(data.data.rft)

        if (data.data.access) {
          if (onboarding) {
            if (urlRedirectType) {
              if (urlRedirectType === "default") {
                history.push('/home')
              } else {
                history.push('/settings/profile')
              }
            }
          } else if (urlRedirectType) {
            if (urlRedirectType !== '_skip_') {
              if (urlRedirectType === "default") {
                history.push('/home')
              } else {
                history.push('/settings/profile')
              }
            }
          } else {
            history.push('/home')
          }
          callback(data)
        } else {

        }
      } else {

      }
    }, (error) => {
      dispatch(request(loaderConstant.LOADING_FALSE));

      dispatch(failure(authConstant.USER_LOGIN_F, error));
    });
  };
}

/**
 * Request Logout
 */
function logout() {
  return async(dispatch, getState) => {
    dispatch(request(authConstant.LOGOUT_R));
    dispatch(request(loaderConstant.LOADING_TRUE));
    let userId = getState().auth.loginUser.id || getState().auth.signup.id;
    let isCustomDomain = getState().profile?.appConfig?.isCustomDomain;
    let device = "WEB";
    const notificationToken = localStorage.getItem("notificationToken")
    let deviceId = await getDeviceId()
    const data = {
      device,
      token: notificationToken,
      user_id: userId,
      deviceId : deviceId
    }
    authService.logout(data).then((data) => {
      localStorage.removeItem("notificationToken")
      localStorage.removeItem("AF_Token_SentToServer")

      try {
        navigator.serviceWorker.getRegistrations().then(registrations => {
          for (const registration of registrations) {
            registration.unregister();
          }
        });
      } catch (err) {
        console.log("Service worker unregister error:", err)
      }

      localStorage.removeItem('emailAddress')
      dispatch(success(authConstant.LOGOUT_S));
      dispatch(request(loaderConstant.LOADING_FALSE));
      history.push(`/login`);
      if (isCustomDomain) {
        window.location.reload();
      }
      removeToken()
    }, error => {
      dispatch(request(loaderConstant.LOADING_FALSE));

      dispatch(failure(authConstant.LOGOUT_F, error));
    })
  };
}

function getUpdatedStatus(params) {
  return (dispatch) => {
    dispatch(request(authConstant.GET_UPDATED_STATUS_R, params));
    dispatch(request(loaderConstant.LOADING_TRUE));
    authService.getUpdatedStatus(params).then(data => {
      dispatch(success(authConstant.GET_UPDATED_STATUS_S, data));
      dispatch(request(loaderConstant.LOADING_FALSE));
    }, error => {
      dispatch(failure(authConstant.GET_UPDATED_STATUS_F, error));

      dispatch(request(loaderConstant.LOADING_FALSE));
    });
  };
}

/**
 * get profile data
 */
function getProfileData(params) {
  return (dispatch) => {
    dispatch(request(authConstant.GET_PROFILE_R));
    dispatch(request(loaderConstant.LOADING_TRUE));
    authService.getProfileData(params).then(data => {
      dispatch(success(authConstant.GET_PROFILE_S, data));
      dispatch(request(loaderConstant.LOADING_FALSE));
      if (data && data["data"]) {
        dispatch(success(authConstant.SHOW_POPUP_LOGIN, { message: "" }));
        dispatch(success(dashboardConstant.UPDATE_REM_TEXT, data["data"]["rText"]));
      }
    }, error => {
      dispatch(failure(authConstant.GET_PROFILE_F, error));

      dispatch(request(loaderConstant.LOADING_FALSE));
    });
  };
}

function pageRedirect(params, cb = () => { }) {
  return () => {
    if (params && params.redirectUrl) {
      history.push(params.redirectUrl)
    } else {
      cb(params)
    }
  };
}

/**
 * Get user login token for the mobile device
 */
function getUserLoginForDevice(params, callback = () => { }){
  return (dispatch) => {
    dispatch(request(loaderConstant.LOADING_TRUE));
    authService.getLoginForDevice(params).then(data => {
      dispatch(success(authConstant.USER_LOGIN_S, data));
      setToken(data.data.token);
      setRfToken(data.data.rft)
      callback(data.data)
      dispatch(request(loaderConstant.LOADING_FALSE));
    }, error => {
      dispatch(request(loaderConstant.LOADING_FALSE));

    })
  }
}

export function updateSocketStatus(data) {
  return (dispatch) => {
    dispatch(success(authConstant.UPDATE_SOCKET_STATUS_S, data));
  };
}
